<template>
  <div v-html="processedHtml" />
</template>
<script>
export default {
  name: 'ProcessedHtml',
  props: {
    processedHtml: String,
  },
};
</script>
